import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_the_fac_failing_to_comply_w_legal_reqs_regarding_worker_resi'

export const dataPointDefinition = {
  retracedId: 'is_the_fac_failing_to_comply_w_legal_reqs_regarding_worker_resi',
  name: "Is the facility failing to comply with legal requirements regarding worker resignation or termination related to: \r\r\n• prior notice, \r\r\n• workers' opportunity to defend, \r\r\n• valid reasons for termination, \r\r\n• outstanding wages, \r\r\n• termination payments, \r\r\n• termination payments all paid on time, \r\r\n• compensation for unused annual leave, and/or \r\r\n• reinstatement/ compensation orders?",
  description:
    'Answer No if the facility is following applicable legal requirements related to issues concerning worker resignation and termination. \r\r\n\r\r\nAnswer Yes if: \r\r\n- Workers were not given notice prior to termination in line with applicable legal requirements; and/or\r\r\n- Workers were not given an opportunity to defend themselves before they were terminated based on their conduct or performance; and/or\r\r\n- Any workers were terminated for invalid reasons; and/or\r\r\n- Workers were not paid correctly for outstanding wages; and/or\r\r\n- Workers were not paid correctly for severance payments; and/or\r\r\n- Workers were not compensated correctly for unused annual leave; and/or\r\r\n- Workers were not paid other termination benefits in line with legal requirements; and/or\r\r\n- The employer did comply with any orders to reinstate or compensate workers who were found to be unjustly terminated.\r\r\n\r\r\nConsult applicable legal requirements before answering this question. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ter-emp-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 17780,
  sectionId: '2.2.4.1',
  impactArea: 'Recruitment, Hiring & Termination Practices',
  impactAreaId: 'RECRUITMENT_HIRING_AND_TERMINATION_PRACTICES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
